export default "__VITE_ASSET__cDOjWZky__"